<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>标题：</label>
                        <el-input v-model="search_Obj.f_title" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>报告日期：</label>
                        <el-input v-model="search_Obj.f_report_date" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="title" label="标题" sortable="custom"></el-table-column>
                        <el-table-column prop="report_date" label="报告日期" sortable="custom"></el-table-column>
                        <el-table-column prop="create_time" label="编制时间" sortable="custom" width="130">
                            <template slot-scope="scope">
                                <span>{{ formatDate1(scope.row.create_time, "yyyy-mm-dd") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="creator_name" label="编制人" sortable="custom" width="130"></el-table-column>
                        <el-table-column prop="sh_name" label="审核人" sortable="custom" width="130"></el-table-column>
                        <el-table-column prop="state" label="状态" sortable="custom" width="130">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.state, "shstate1") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="280" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" :ignore_ids="',1936,'" @on_btnclk="labelClick" v-if="scope.row.state==0"></LabBtns>
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick" v-else></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Edit
                    width="1000px"
                    :id="model_id"
                    :title="edit_title"
                    :isshow="editshow"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <Exam
                    width="1000px"
                    :id="model_id"
                    title="审核"
                    :isshow="examshow"
                    @on-close="closeExamDialog"
                    @on-save-ok="examOk">
                </Exam>
                <UserList
                    width="1100px"
                    :id="model_id"
                    title="推送用户管理"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </UserList>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Exam from "./exam"
import UserList from "./userlist"
import listutil from "@/libs/listutil"

export default {
    name: 'dayReportList',
    mixins: [listutil],
    components: {Edit, UserList, Btns, LabBtns, Exam},
    data() {
        return {
            m_name: '日常快报推送',
            menu_id: 1930,
            list_url: "/api/admin/dayreport/list",
            search_Obj: {
                f_title: '',
                f_report_date: '',
            },
            del_Obj:{
                url:'/api/admin/dayreport/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['shstate1'],
            examshow: false,
        };
    },
    methods: {
        userList(index, row) {
            this.model_id = row.id
            this.infoshow = true
        },
        exam(index, row) {
            this.model_id = row.id
            this.examshow = true
        },
        examOk() {
            this.examshow = false
            this.getListData()
        },
        closeExamDialog(){
            this.examshow = false
        },
    }
};
</script>